module.exports = __webpack_public_path__ + "img/tumblr_oopx3kFunI1scmex7o1_500.jpg";